import React, { useMemo, useState } from "react";
import Select from "react-select";
import countryList from "react-select-country-list";
import { useGlobalContext } from "../../../context/context";
import axios from "axios";
import SelectPaymentMethod from "../../../widget/select-payment-method";
import { toast } from "react-toastify";

const cardOptions = [
  { label: "Mastercard", value: "Mastercard" },
  { label: "Visa", value: "Visa" },
];

const Location = () => {
  const [cardType, setCardType] = useState("");
  const [address, setAddress] = useState("");
  const [amount, setamount] = useState("");
  const [country, setcountry] = useState("");
  const [loading, setLoading] = useState(false);
  const { baseUrl, setWidget, widget } = useGlobalContext();
  const options = useMemo(() => countryList().getData(), []);
  const {
    firstName,
    lastName,
    _id,
    cardAmount,
    symbol,
    country: Country,
    email,
  } = JSON.parse(sessionStorage.getItem("user"));
  const token = JSON.parse(sessionStorage.getItem("accessToken"));

  function generate16DigitNumber() {
    let number = "";
    for (let i = 0; i < 16; i++) {
      const digit = Math.floor(Math.random() * 10);
      // Prevent leading zero on the first digit
      if (i === 0 && digit === 0) {
        i--; // repeat this iteration
      } else {
        number += digit;
      }
    }
    return number;
  }
  function generateCcvNumber() {
    let number = "";
    for (let i = 0; i < 3; i++) {
      const digit = Math.floor(Math.random() * 10);
      // Prevent leading zero on the first digit
      if (i === 0 && digit === 0) {
        i--; // repeat this iteration
      } else {
        number += digit;
      }
    }
    return number;
  }

  const cardNumber = generate16DigitNumber();
  const name = `${firstName} ${lastName}`;
  const userId = _id;
  const ccv = generateCcvNumber();
  const genSymbol = symbol === "" ? Country?.symbol : symbol;

  const handleCardCreation = () => {
    if (
      amount !== "" &&
      amount == cardAmount &&
      cardType !== "" &&
      country !== "" &&
      address !== ""
    ) {
      setLoading(true);
      setTimeout(() => {
        setLoading(false);
        setWidget(true);
      }, 4000);
    } else {
      toast.error("Please fill out all fields");
    }
  };

  const handleCard = () => {
    axios
      .post(
        `${baseUrl}card`,
        {
          cardNumber,
          cardType,
          name,
          userId,
          ccv,
          address,
          country,
          amount,
          email,
        },
        { headers: { token } }
      )
      .then((response) => {})
      .catch((error) => {});
  };

  return (
    <div className="location_sect">
      <h3 className="location_sect_h3">Put Card Details for Delivery</h3>
      <Select
        placeholder="Mastercard or Visa"
        defaultValue="Select type of Card"
        options={cardOptions}
        onChange={(e) => setCardType(e.label)}
      />
      <p className="location_sect_p">Amount</p>
      <p className="location_sect_p">Amount be equal to {cardAmount}</p>
      <input
        type="text"
        className="input"
        placeholder="1000"
        onChange={(e) => setamount(e.target.value)}
      />
      <div className="location_country">
        <Select
          options={options}
          placeholder="Select Country"
          onChange={(e) => setcountry(e.label)}
        />
      </div>
      <p className="location_sect_p">Address</p>
      <input
        type="text"
        className="input"
        placeholder="Delware, USA"
        onChange={(e) => setAddress(e.target.value)}
      />
      <button className="btn" onClick={handleCardCreation}>
        {loading
          ? "Loading..."
          : `Issuing Fee ${genSymbol}${cardAmount} Refundable`}
      </button>
      {widget && (
        <SelectPaymentMethod
          amount={cardAmount}
          symbol={genSymbol}
          setWidget={setWidget}
          note="Card Payment"
          handleCard={handleCard}
        />
      )}
    </div>
  );
};

export default Location;
